export const emailTypes = {
	'reservations':	'Reservations',
	'hire':			'Venue Hire',
	'perform':		'Performance Enquiries',
	'work':			'Work for us',
	'contact':		'Contact',
	'custom':		'Other'
};
